// @flow
import { _get, _patch, _post } from "./methods";

export default {
  dashboard: (params: any) => _get("/admin/place_ingestion/dashboard", params),
  cities: {
    create: (data: any) => _post("/admin/place_ingestion/cities", data),
    update: ({ id, ...data }: any) =>
      _patch(`/admin/place_ingestion/cities/${id}`, data),
    discover: ({ id }: any) =>
      _post(`/admin/place_ingestion/cities/${id}/discover`, {}),
    selectTopMix: ({ id }: any) =>
      _post(`/admin/place_ingestion/cities/${id}/select-top-mix`, {}),
    enrich: ({ id, candidate_ids }: any) =>
      _post(`/admin/place_ingestion/cities/${id}/enrich`, { candidate_ids })
  },
  runs: {
    sync: ({ id }: any) =>
      _post(`/admin/place_ingestion/runs/${id}/sync`, {})
  },
  candidates: {
    select: (data: any) =>
      _post("/admin/place_ingestion/candidates/select", data),
    prepareContent: (candidate_ids: number[]) =>
      _post("/admin/place_ingestion/candidates/content", { candidate_ids }),
    publish: (candidate_ids: number[]) =>
      _post("/admin/place_ingestion/candidates/publish", { candidate_ids }),
    importPhotos: (
      candidate_ids: number[],
      limit_per_place: number = 6,
      max_photos: number = 3
    ) =>
      _post("/admin/place_ingestion/candidates/photos", {
        candidate_ids,
        limit_per_place,
        max_photos
      }),
    verify: (candidate_ids: number[]) =>
      _post("/admin/place_ingestion/candidates/verify", { candidate_ids })
  },
  importDataset: (data: any) =>
    _post("/admin/place_ingestion/datasets/import", data)
};
